import React from 'react'
import questionIcon from '../../../assets/question-mark.svg';
import './sabiasQue.scss';

type TSabiasQue = {
	img: string,
	description: Array<{ id: number, name: string }>;
}

const SabiasQue = (props: TSabiasQue) => {
	return (
		<div className="m-sabias-que">
			<img className="m-sabias-que__icon" src={props.img || questionIcon} alt="¿Sabías qué?"></img>
			<h2 className="m-sabias-que__title">¿Sabías qué?</h2>
			{
				props.description.map((text) => (
					<p className="m-sabias-que__text" key={text.id}>{text.name}</p>
				))
			}
		</div>
	)
}

export default SabiasQue